import React, { useEffect, useState } from "react";
import KanbanBoardContainer from "../utilities/KanbanBoardContainer";
import { fetchMembers } from "../../store/actions/adminActions";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "react-bootstrap";

function SummaryReport() {
	const { members } = useSelector((state) => state.admin);
	const dispatch = useDispatch();
	const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

	useEffect(() => {
		dispatch(fetchMembers());
	}, [dispatch]);

	// Process the data to flatten nested objects
	const processData = (members) => {
		return members.map((member, index) => {
			const flattenedMember = flattenObj({ ...member, serial: index + 1 });
			delete flattenedMember.paymentDetails;
			return flattenedMember;
		});
	};

	const flattenObj = (obj) => {
		let result = {};
		for (const i in obj) {
			if (typeof obj[i] === "object" && !Array.isArray(obj[i]) && obj[i] !== null) {
				const temp = flattenObj(obj[i]);
				for (const j in temp) {
					result[j] = temp[j];
				}
			} else {
				result[i] = obj[i];
			}
		}
		return result;
	};

	const data = processData(members);

	// Sorting logic
	const requestSort = (key) => {
		let direction = 'ascending';
		if (sortConfig.key === key && sortConfig.direction === 'ascending') {
			direction = 'descending';
		}
		setSortConfig({ key, direction });
	};

	const getSortedData = (data) => {
		if (!sortConfig.key) return data;

		return [...data].sort((a, b) => {
			if (a[sortConfig.key] < b[sortConfig.key]) {
				return sortConfig.direction === 'ascending' ? -1 : 1;
			}
			if (a[sortConfig.key] > b[sortConfig.key]) {
				return sortConfig.direction === 'ascending' ? 1 : -1;
			}
			return 0;
		});
	};

	const sortedData = getSortedData(data);

	// Column definitions
	const columns = [
		{ key: "serial", label: "#", width: "50px", sortable: false },
		{ key: "name", label: "Name", width: "200px", sortable: true },
		{ key: "memberId", label: "Membership Number", width: "200px", sortable: false },
		{ key: "accountName", label: "Account Holder Name", width: "200px", sortable: false },
		{ key: "accountNumber", label: "Account Number", width: "200px", sortable: false },
		{ key: "bankName", label: "Bank Name", width: "200px", sortable: false },
	];

	// Export to CSV function
	const exportToCSV = () => {
		const headers = columns.map(col => col.label).join(',');
		const rows = data.map(item => {
			return columns.map(col => {
				// Handle commas and quotes in CSV fields
				const cellValue = item[col.key] || '';
				const formattedValue = typeof cellValue === 'string' && cellValue.includes(',')
					? `"${cellValue}"`
					: cellValue;
				return formattedValue;
			}).join(',');
		}).join('\n');

		const csvContent = `${headers}\n${rows}`;
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'members_bank_report.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<KanbanBoardContainer>
			<div className="card">
				<div className="card-header">
					<h3 className="card-title">Members Bank Report</h3>
				</div>
				<section className="content pb-3">
					<div className="card-body">
						<div className="text-right mb-3">
							<Button variant="primary" size="lg" onClick={exportToCSV}>
								Export To CSV
							</Button>
						</div>
						<hr />
						<div className="table-responsive">
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										{columns.map((column) => (
											<th
												key={column.key}
												style={{
													backgroundColor: "#c8e6c9",
													width: column.width,
													cursor: column.sortable ? 'pointer' : 'default'
												}}
												onClick={() => column.sortable ? requestSort(column.key) : null}
											>
												{column.label}
												{column.sortable && (
													<span className="ml-1">
														{sortConfig.key === column.key ? (
															sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'
														) : ' ⇅'}
													</span>
												)}
											</th>
										))}
									</tr>
								</thead>
								<tbody>
									{sortedData.map((row, rowIndex) => (
										<tr key={row._id || rowIndex}>
											{columns.map((column) => (
												<td key={`${rowIndex}-${column.key}`}>
													{row[column.key]}
												</td>
											))}
										</tr>
									))}
									{sortedData.length === 0 && (
										<tr>
											<td colSpan={columns.length} className="text-center text-muted">
												No data available
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</KanbanBoardContainer>
	);
}

export default SummaryReport;